export const isExampleNotification = notification => {
  return notification.type === 10001;
};